import React, { Component } from 'react';
import language from '../../../assets/languages/language';
import App_data from '../../config/App_data';
import {
  getTokenAndEmail,
  mutateReportVideo,
  reportCBTQuestion,
  reportQuestion,
} from '../services';
export class Report extends Component {
  constructor(props) {
    super(props);
    this.state = {
      reportLoading: false,
      successAlert: false,
      comment: '',
    };
  }

  report = async () => {
    const { comment } = this.state;
    const { commentOnWhichId, section = '', mockData } = this.props;
    this.setState({ reportLoading: true });
    const data = {
      ...getTokenAndEmail(),
      commentOnWhichId,
      comment,
      mockData,
    };
    let apiService = reportQuestion;

    switch (section.toLowerCase()) {
      case 'cbt':
        apiService = reportCBTQuestion;
        break;
      case 'video':
        apiService = mutateReportVideo;
        break;

      default:
        apiService = reportQuestion;
        break;
    }

    const response = await apiService(data);
    if (response.success) {
      this.setState({ successAlert: true, comment: '' });
    }
    this.setState({ reportLoading: false });
  };

  render() {
    const { reportLoading, comment } = this.state;
    const { hideReportSection } = this.props;
    return (
      <div className='row'>
        <div className='col-md-12'>
          <div className='card'>
            <div className='card-header'>{language.LC().REPORT}</div>
            {!this.state.successAlert ? (
              <div className='card-block'>
                <div className='row'>
                  <div className='col-xs-12 col-sm-12 col-md-12'>
                    <label className='form-control-label' htmlFor='textarea-input'>
                      <strong>{language.LC().COMMENT}</strong>
                    </label>
                  </div>
                  <div className='col-xs-12 col-sm-12 col-md-12 margin_bottom_10'>
                    <textarea
                      onChange={event => this.setState({ [event.target.name]: event.target.value })}
                      id='comment'
                      name='comment'
                      rows='6'
                      value={comment}
                      className='form-control'
                      placeholder='Content..'
                    />
                  </div>
                </div>
                <div className='row'>
                  <div className='col-xs-12 col-sm-12 col-md-12'>
                    <button
                      type='button'
                      className='btn btn-primary active pointer_class report-btn'
                      disabled={reportLoading}
                      onClick={this.report}
                    >
                      {reportLoading ? language.LC().PLEASE_WAIT : language.LC().REPORT}
                    </button>
                    <button
                      type='button'
                      className='btn btn-danger active pointer_class margin_left_10'
                      onClick={hideReportSection}
                    >
                      {language.LC().CANCEL}
                    </button>
                  </div>
                </div>
              </div>
            ) : (
              <div className='card-block'>
                <div className='row'>
                  <div className='col-sm-12 report-Success-card'>
                    <img src={`${App_data.frontend_url}/img/success-ic.svg`} alt='' />
                    <label className='form-control-label' htmlFor='textarea-input'>
                      <strong> {language.LC().REPORT_SEND_SUCCESS_MESSAGE}</strong>
                    </label>
                    <button
                      type='button'
                      className='btn btn-primary active pointer_class  min-vw-120'
                      onClick={hideReportSection}
                    >
                      {' '}
                      {language.LC().CLOSE}
                    </button>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}

export default Report;



// WEBPACK FOOTER //
// ./src/views/ESG/Report/index.js